import React, {useEffect, useState} from 'react'
import TruckLineIcon from 'remixicon-react/TruckLineIcon'
import styled from 'styled-components'
import {theme} from 'src/themes'
import {formatNumber} from 'src/utils/numbers'
import {useCheckout} from 'src/context/CheckoutContext'
import {Alert} from '../common'
import {P} from '../typography'

const Wrapper = styled.div`
  margin: 16px 0;
`
const Content = styled.div`
  display: inline-flex;
  flex-wrap: wrap;

  svg {
    margin-right: 16px;
    margin-bottom: 6px;
  }
`

const shippingLabel =
  'Sendingarkostnaður fellur niður ef þú bætir vörum í körfuna fyrir'
const freeShippingLabel = 'Frír sendingarkostnaður virkjaður!'

interface Props {
  shipmentPricingThreshold?: number | null
}

export const CartShipmentPricingAlert = ({
  shipmentPricingThreshold,
}: Props): JSX.Element => {
  const {checkout} = useCheckout()
  const [isOpen, setIsOpen] = useState<boolean>(true)

  const totalProdPrice = checkout?.subtotalPrice?.gross?.amount
  const isActivatedFreeShipping =
    shipmentPricingThreshold &&
    totalProdPrice &&
    totalProdPrice > shipmentPricingThreshold
  const amountNeeded =
    shipmentPricingThreshold && shipmentPricingThreshold - (totalProdPrice ?? 0)

  useEffect(() => {
    if (!isOpen && isActivatedFreeShipping) {
      setIsOpen(true)
    }
  }, [isOpen, isActivatedFreeShipping])

  return (
    <>
      {shipmentPricingThreshold && amountNeeded && (
        <Wrapper>
          <Alert
            type={!isActivatedFreeShipping ? 'warning' : 'success'}
            open={isOpen}
            setOpen={setIsOpen}
          >
            <Content>
              <TruckLineIcon
                color={
                  !isActivatedFreeShipping
                    ? theme.palette.warning
                    : theme.palette.success
                }
                size={24}
              />
              <P>
                {!isActivatedFreeShipping ? shippingLabel : freeShippingLabel}{' '}
                {!isActivatedFreeShipping && (
                  <b>{formatNumber(amountNeeded)} kr.</b>
                )}
              </P>
            </Content>
          </Alert>
        </Wrapper>
      )}
    </>
  )
}
